import React from 'react'
import { css } from '@emotion/react'
import { toUnitNumber } from '@/lib/number'
import { OverseasIpoData } from '../../../../../types/api'
import { SummaryLabel } from './OverseasCompanySummary'
import { SummaryLabelAnnotation } from '../domestic/CompanySummary'
import { SummaryAmountWithCurrency } from './SummaryAmountWithCurrency'
import { font } from 'plume-ui'

type Props = {
  ipoData: OverseasIpoData
}

export const IpoValuationInfo: React.VFC<Props> = (props) => {
  if (
    !props.ipoData ||
    !props.ipoData.valuation.value ||
    !props.ipoData.valuation.currency
  )
    return (
      <div
        className="ipo-valuation"
        css={css`
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
        `}
      >
        <div>
          <SummaryLabel>
            IPO時時価総額
            <SummaryLabelAnnotation>（公開価格）</SummaryLabelAnnotation>
          </SummaryLabel>
        </div>
        <div
          className="value"
          css={css`
            font-style: normal;
            font-weight: ${font.weight.normal};
            font-size: 32px;
            height: 48px;
            display: flex;
            align-items: center;
            line-height: 75%;
          `}
        >
          -
        </div>
      </div>
    )
  const unitNumber = toUnitNumber(props.ipoData.valuation.value)
  return (
    <div
      className="ipo-valuation"
      css={css`
        display: flex;
        width: 176px;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
      `}
    >
      <div>
        <SummaryLabel>
          IPO時時価総額
          <SummaryLabelAnnotation>（公開価格）</SummaryLabelAnnotation>
        </SummaryLabel>
      </div>
      <div
        className="values"
        css={css`
          display: flex;
          height: 48px;
          flex-direction: row;
          align-items: center;
          justify-content: center;
        `}
      >
        <SummaryAmountWithCurrency
          amount={unitNumber}
          currency={props.ipoData.valuation.currency}
        />
      </div>
    </div>
  )
}
